import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { Provider } from 'rebass'
import { injectGlobal } from 'styled-components'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faLightbulb, faBook, faCogs } from '@fortawesome/free-solid-svg-icons'

library.add(fab, faBook, faCogs, faLightbulb)

injectGlobal`
  * { box-sizing: border-box; }
  body { margin: 1em; }
`
const TemplateWrapper = ({ children }) => (
  <Provider>
    <Helmet title="Symfony React SSR Workshop" />
    <div>{children()}</div>
  </Provider>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js